// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slider-container {
    width: 100% !important; /* Adjust the width as needed */
    margin: 0 auto !important; /* Center the slider */
  }
  

.slick-slider {
    padding: 0px;
}
@media screen and (max-width: 768px) {

    .customArrow_customer_right {
        border-radius: 50%;
        padding: 10px;
        background-color: white;
        margin-right:-160px
        
    }
    .customArrow_customer_left {
        border-radius: 50%;
        padding: 10px;
        background-color: white;
        margin-left: -160px    }
}

.font_similar_card{
    font-weight: 400;
    font-size: 24px;
    line-height: 32px;
    color: var(--darkblue);
}
@media screen and (min-width: 319px) and (max-width:400px) {
    .slick-list{
        margin: 0px 35px !important;
    }
}
@media screen and (max-width: 400px) {
    .responsive_checout_transaction{
        padding: 0px !important;
    }
}
@media screen and (min-width: 401px) and (max-width:440px) {
    .slick-list{
        margin: 0px 45px !important;
    }
}
@media screen and (min-width: 440px) and (max-width:500px) {
    .slick-list{
        margin: 0px 70px !important;
    }
}
@media screen and (min-width: 500px) and (max-width:530px) {
    .slick-list{
        margin: 0px 90px !important;
    }
}
@media screen and (max-width: 492px) {
    .responsive_class_width_banner{
        width: 80%;
        margin-left: 35px;
    }
    .carousel-button.next-button {
        right: -3px;
    }
    .carousel-button.prev-button {
        left: -3px;
    }
}
@media screen and (min-width: 1400px)  {
    .slick-list{
        margin: 0px 65px !important;
    }
    .responsive_fixed_bottom{
        position: absolute;
        bottom: 10px;
        width: 100%;
        right: -6px;
    }
    .responsive_main_div{
        position: relative;
    }
}
@media screen and (min-width: 1400px) and (max-width:1440px) {
    .slick-list{
        margin: 0px 45px !important;
    }
}
@media screen and (min-width: 1350px) and (max-width:1399px) {
    .slick-list{
        margin: 0px 39px !important;
    }
}
@media screen and (min-width: 1200px) and (max-width:1349px) {
    .slick-list{
        margin: 0px 25px !important;
    }
    .carousel-button.next-button {
        right: -15px;
    }
    .carousel-button.prev-button {
        left: -15px;
    }
}
@media screen and (min-width: 1150px) and (max-width:1199px) {
    .slick-list{
        margin: 0px 100px !important;
    }
}
@media screen and (min-width: 900px) and (max-width:1149px) {
    .slick-list{
        margin: 0px 40px !important;
    }
}
@media screen and (min-width: 700px) and (max-width:899px) {
    .slick-list{
        margin: 0px 40px !important;
    }
}
@media screen and (min-width: 531px) and (max-width:799px) {
    .slick-list{
        margin: 0px 40px !important;
    }
}

.redeem_hover:hover{
    box-shadow: 1px 1px 5px rgb(0,0,0) !important;
    opacity: 0.95;
    transition:  box-shadow 0.3s ease;
    font-weight: 700;
}

.terms_hover:hover {
    text-shadow: 2px 2px 4px #0d6dfd77;
}
.trash_icon:hover {
    color: #000000 !important;
    transform: scale(1.2);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }

  .similar_hover:hover{
    transform: scale(1.015);
    transition: all 0.3s ease;
    box-shadow: 0 0px 5px rgb(7, 7, 7);
}
.card_image_style:hover{
    border-color: rgb(7, 7, 7);
  }`, "",{"version":3,"sources":["webpack://./src/components/checkComp.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB,EAAE,+BAA+B;IACvD,yBAAyB,EAAE,sBAAsB;EACnD;;;AAGF;IACI,YAAY;AAChB;AACA;;IAEI;QACI,kBAAkB;QAClB,aAAa;QACb,uBAAuB;QACvB;;IAEJ;IACA;QACI,kBAAkB;QAClB,aAAa;QACb,uBAAuB;QACvB,uBAAuB;AAC/B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI;QACI,2BAA2B;IAC/B;AACJ;AACA;IACI;QACI,uBAAuB;IAC3B;AACJ;AACA;IACI;QACI,2BAA2B;IAC/B;AACJ;AACA;IACI;QACI,2BAA2B;IAC/B;AACJ;AACA;IACI;QACI,2BAA2B;IAC/B;AACJ;AACA;IACI;QACI,UAAU;QACV,iBAAiB;IACrB;IACA;QACI,WAAW;IACf;IACA;QACI,UAAU;IACd;AACJ;AACA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,kBAAkB;QAClB,YAAY;QACZ,WAAW;QACX,WAAW;IACf;IACA;QACI,kBAAkB;IACtB;AACJ;AACA;IACI;QACI,2BAA2B;IAC/B;AACJ;AACA;IACI;QACI,2BAA2B;IAC/B;AACJ;AACA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,YAAY;IAChB;IACA;QACI,WAAW;IACf;AACJ;AACA;IACI;QACI,4BAA4B;IAChC;AACJ;AACA;IACI;QACI,2BAA2B;IAC/B;AACJ;AACA;IACI;QACI,2BAA2B;IAC/B;AACJ;AACA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,6CAA6C;IAC7C,aAAa;IACb,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;AACtC;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,wCAAwC;EAC1C;;EAEA;IACE,uBAAuB;IACvB,yBAAyB;IACzB,kCAAkC;AACtC;AACA;IACI,0BAA0B;EAC5B","sourcesContent":[".slider-container {\n    width: 100% !important; /* Adjust the width as needed */\n    margin: 0 auto !important; /* Center the slider */\n  }\n  \n\n.slick-slider {\n    padding: 0px;\n}\n@media screen and (max-width: 768px) {\n\n    .customArrow_customer_right {\n        border-radius: 50%;\n        padding: 10px;\n        background-color: white;\n        margin-right:-160px\n        \n    }\n    .customArrow_customer_left {\n        border-radius: 50%;\n        padding: 10px;\n        background-color: white;\n        margin-left: -160px    }\n}\n\n.font_similar_card{\n    font-weight: 400;\n    font-size: 24px;\n    line-height: 32px;\n    color: var(--darkblue);\n}\n@media screen and (min-width: 319px) and (max-width:400px) {\n    .slick-list{\n        margin: 0px 35px !important;\n    }\n}\n@media screen and (max-width: 400px) {\n    .responsive_checout_transaction{\n        padding: 0px !important;\n    }\n}\n@media screen and (min-width: 401px) and (max-width:440px) {\n    .slick-list{\n        margin: 0px 45px !important;\n    }\n}\n@media screen and (min-width: 440px) and (max-width:500px) {\n    .slick-list{\n        margin: 0px 70px !important;\n    }\n}\n@media screen and (min-width: 500px) and (max-width:530px) {\n    .slick-list{\n        margin: 0px 90px !important;\n    }\n}\n@media screen and (max-width: 492px) {\n    .responsive_class_width_banner{\n        width: 80%;\n        margin-left: 35px;\n    }\n    .carousel-button.next-button {\n        right: -3px;\n    }\n    .carousel-button.prev-button {\n        left: -3px;\n    }\n}\n@media screen and (min-width: 1400px)  {\n    .slick-list{\n        margin: 0px 65px !important;\n    }\n    .responsive_fixed_bottom{\n        position: absolute;\n        bottom: 10px;\n        width: 100%;\n        right: -6px;\n    }\n    .responsive_main_div{\n        position: relative;\n    }\n}\n@media screen and (min-width: 1400px) and (max-width:1440px) {\n    .slick-list{\n        margin: 0px 45px !important;\n    }\n}\n@media screen and (min-width: 1350px) and (max-width:1399px) {\n    .slick-list{\n        margin: 0px 39px !important;\n    }\n}\n@media screen and (min-width: 1200px) and (max-width:1349px) {\n    .slick-list{\n        margin: 0px 25px !important;\n    }\n    .carousel-button.next-button {\n        right: -15px;\n    }\n    .carousel-button.prev-button {\n        left: -15px;\n    }\n}\n@media screen and (min-width: 1150px) and (max-width:1199px) {\n    .slick-list{\n        margin: 0px 100px !important;\n    }\n}\n@media screen and (min-width: 900px) and (max-width:1149px) {\n    .slick-list{\n        margin: 0px 40px !important;\n    }\n}\n@media screen and (min-width: 700px) and (max-width:899px) {\n    .slick-list{\n        margin: 0px 40px !important;\n    }\n}\n@media screen and (min-width: 531px) and (max-width:799px) {\n    .slick-list{\n        margin: 0px 40px !important;\n    }\n}\n\n.redeem_hover:hover{\n    box-shadow: 1px 1px 5px rgb(0,0,0) !important;\n    opacity: 0.95;\n    transition:  box-shadow 0.3s ease;\n    font-weight: 700;\n}\n\n.terms_hover:hover {\n    text-shadow: 2px 2px 4px #0d6dfd77;\n}\n.trash_icon:hover {\n    color: #000000 !important;\n    transform: scale(1.2);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  }\n\n  .similar_hover:hover{\n    transform: scale(1.015);\n    transition: all 0.3s ease;\n    box-shadow: 0 0px 5px rgb(7, 7, 7);\n}\n.card_image_style:hover{\n    border-color: rgb(7, 7, 7);\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
